import {
  ENTITY_LEVEL,
  SIDE_NAV_BAR_OPTIONS,
} from '../../../../common/constants/integrationConstants/supportConstants';
import { changeConfigTab } from '../../../routines/integrations/supportIntegrationRoutines';

const initialState = {
  entityTab: ENTITY_LEVEL.TICKET,
  sideNavBarTab: SIDE_NAV_BAR_OPTIONS.TICKET_DEDUPLICATION,
};
const getEntityChangeLocation = (entityTab) => ({
  entityTab,
  sideNavBarTab:
    entityTab === ENTITY_LEVEL.TICKET
      ? SIDE_NAV_BAR_OPTIONS.TICKET_DEDUPLICATION
      : SIDE_NAV_BAR_OPTIONS.ENTITY_DEDUPLICATION,
});
export const findLocation = ({ entityTab, sideNavBarTab }) => {
  if (entityTab && !sideNavBarTab) return getEntityChangeLocation(entityTab);
  return {
    entityTab,
    sideNavBarTab,
  };
};
const intercomNavigationReducer = (state = initialState, action) => {
  switch (action.type) {
    case changeConfigTab.TRIGGER: {
      const { entityTab, sideNavBarTab } = action.payload;
      const newLocation = findLocation({ entityTab, sideNavBarTab });

      return {
        ...state,
        ...newLocation,
      };
    }
    default:
      return state;
  }
};

export default intercomNavigationReducer;
